import { useEffect, useState } from "react";
import localeText from "../../../../locale";

// Valor com botão de copiar (IBAN, e-mail PayPal, carteira...), útil ao processar pagamentos
const CopyValue = ({ value, label, mono = false }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  if (!value) return <span className="admin-muted">—</span>;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <span className="admin-copy">
      {label && <span className="admin-copy__label">{label}</span>}
      <span className={mono ? "admin-copy__value admin-copy__value--mono" : "admin-copy__value"}>
        {value}
      </span>
      <button
        type="button"
        className="admin-copy__button"
        onClick={copy}
        aria-label={`${localeText("adminListCopy")} ${label || ""}`.trim()}
        title={localeText(copied ? "adminListCopied" : "adminListCopy")}
      >
        <i className={copied ? "pi pi-check" : "pi pi-copy"} aria-hidden="true" />
      </button>
    </span>
  );
};

export default CopyValue;
